import noProductsImage from '@/assets/images/common/no-products.svg';
import { getPageFromPath } from '@/common/utils/pathHelper';
import Gallery from '@/components/Gallery';
import { cn } from '@/lib/utils';
import { Advertisement, Maybe } from '@/types/graphql.prod';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';

export const Content = ({
  noProducts,
  items,
  ads,
}: {
  noProducts: boolean;
  items: any[];
  ads: Maybe<Maybe<Advertisement>[]> | undefined;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const categoryPathName = pathname?.split('/')?.[1];

  if (noProducts) {
    return (
      <div className={cn('flex flex-col items-center')}>
        <h2 className='font-paytone px-[15px] text-[22px] uppercase leading-[40px] text-primary lg_px-0'>
          SORRY! WE COULDN&apos;T FIND ANY PRODUCTS.
        </h2>
        <div className='mb-[50px] px-[15px] font-sans text-title lg_px-0'>
          Looks like your search filters are having a party and forgot to invite any results! Try{' '}
          <span
            className='cursor-pointer text-primary underline'
            onClick={() => {
              router.push(`/${categoryPathName}`);
            }}
          >
            reset filters
          </span>{' '}
          to let some more options join the fun!
        </div>
        <div>
          <Image
            src={noProductsImage}
            className={cn('h-auto w-[513px]')}
            alt='no products'
          />
        </div>
      </div>
    );
  }

  return (
    <Gallery
      items={items}
      ads={ads}
      pageControl={{
        currentPage: getPageFromPath(pathname),
      }}
    />
  );
};
